import React from 'react';
import DonationComponent from '../DonationComponent/DonationComponent';

import shape1 from '../../images/donate-shape.svg'
import shape2 from '../../images/donate-1.svg'
import shape3 from '../../images/donate-2.svg'
import shape4 from '../../images/donate-3.svg'
import donationBg from '../../images/banner/donation-bg.jpeg'

const GetQuateSection = (props) => {
    return (
        <section className={"" +props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="left-wrap">
                            <h2>Support Our Mosque Fund</h2>
                            <h3>Make a <span>Donation</span> Today</h3>
                            <p>Your contribution helps us build a mosque for the Point Cook Muslim
                                community. Every donation brings us closer to our $500,000 goal.
                                We have raised $175,000 so far.</p>
                            <ul className="icontext">
                                <li><i className="flaticon-fund"></i>$175,000 Raised
                                    35% of Goal</li>
                                <li><i className="flaticon-cardiogram"></i>$325,000 Remaining
                                    to Reach Target</li>
                            </ul>
                            <ul className="op-item">
                                <li><i className="flaticon-check"></i>Secure Payment via Stripe</li>
                                <li><i className="flaticon-check"></i>Tax Deductible Donations</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="donation-from">
                            <h3>Donate to the Mosque Fund</h3>
                            <DonationComponent/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-shape">
                <img src={shape1} alt="" />
                    <div className="shape1">
                    <img src={shape2} alt="" />
                    </div>
                    <div className="shape2">
                    <img src={shape3} alt="" />
                    </div>
                    <div className="shape3">
                    <img src={shape4} alt="" />
                    </div>
            </div>
            <div className="right-img">
                <img src={donationBg} alt="" />
            </div>
        </section>
    );
};

export default GetQuateSection;